export const generateGuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const generateCode = () => {
  return Math.random().toString(36).substring(2, 7).toUpperCase();
};

// Function to format numbers with commas
export const formatAmount = (amount) => {
  if (!amount) return 0;

  amount = parseFloat(amount);
  const formattedAmount = amount.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  // Remove .00 if it exists
  return formattedAmount.replace(/\.00$/, "");
};

export const formatTime = (utcDate, format = "long") => {
  if (!utcDate) return null; // Handle invalid input

  const date = new Date(utcDate); // Convert input to Date object

  // Convert to local time
  if (format === "long")
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  else if (format === "short") {
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
      .format(date)
      .toUpperCase();
  } else {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
};

// Function to load the Razorpay script dynamically
export const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.body.appendChild(script);
  });
};
